module.exports = __webpack_public_path__ + "static/media/profile.e4b699f0.jpg";